import { Fragment } from 'react';
import { prismicSliceToCheckboxInput } from 'prismic/slices/CheckboxInput/CheckboxInputSlice';
import { prismicSliceToTextInput } from 'prismic/slices/FormInput/FormInputSlice';
import {
  FormSlices as PrismicFormSlices,
  FormSlicesCheckbox_Input,
  FormSlicesForm_Input,
} from 'prismic-types';

import { Section } from 'components/section/Section';

type Props = {
  data?: Array<PrismicFormSlices>;
};

export const FormSlices = ({ data = [] }: Props) => {
  return (
    <>
      {data.map((s, i) => {
        const key = `slice-${s.type}-${i}`;

        switch (s.type) {
          case 'form_input':
            return (
              <Fragment key={key}>
                {prismicSliceToTextInput(s as FormSlicesForm_Input)}
              </Fragment>
            );
          case 'checkbox_input':
            return (
              <Fragment key={key}>
                {prismicSliceToCheckboxInput(s as FormSlicesCheckbox_Input)}
              </Fragment>
            );
          default:
            console.info(`FormSlices: unknown slice type ${s.type}`, s);
            return process.env.NODE_ENV === 'production' ? null : (
              <Section key={key}>{`unknown slice type ${s.type}`}</Section>
            );
        }
      })}
    </>
  );
};
